import { CFormSelect } from "@coreui/react"
import { useTranslation } from "react-i18next"
import { enToPersianChar } from "../../../../components/helper"
import { useLocation } from "react-router-dom"
import bpLogo from '../../../../assets/images/BMImage.png'
import { useRef } from "react"

const PayPageContent = ({
    selected,
    setSelect,
    price = 0,
    currency,
    user,
    invoiceId,
    status,
    showModal,
    setShowModal,
    duration,
    from,
    nowPaymentsAction,
    closePage,
    purchasedPackage,
    invoiceDetail

}) => {
    const { t, i18n } = useTranslation()
    const location = useLocation()
    const formRef = useRef(null);
    const handleDisplayDuration = () => {

        if (i18n.language === 'fa') {

            if (location.state?._duration) {
                if (location.state?._duration[0].title === "Month") {
                    return ("(یک‌‌‌‌ماهه)")
                } else if (location.state?._duration[0].title === "Year") {
                    return ("(یک‌ساله)")
                } else {
                    return ("(یک‌روزه)")

                }
            }



        }
    }

    const returnCurrency = () => {
        return i18n.language === 'fa' ? " تومان" : " $";
    }

    const triggerSubmit = () => {
        if (formRef.current) {
            
            localStorage.setItem("payRef", "panel")
            formRef.current.submit();
        }
    };

    return (
        <>
            <div className='form-holder d-flex flex-column justify-content-between'>
                {purchasedPackage ? <div> <label style={{ color: '#667085' }}>{t('TITLE.SERVICE_INVOICE')} : </label>  {purchasedPackage?.package.packageTypeTitleFa}
                    {handleDisplayDuration()}
                </div> : location.state?.package ? location.state?.package && <div> <label style={{ color: '#667085' }}>{t('TITLE.SERVICE_INVOICE')} : </label>سرویس  {location.state?.package?.package.packageTypeTitleFa}
                    {handleDisplayDuration()}
                </div> : null

                    // <div><label style={{ color: '#667085' }}>{t('TITLE.SERVICE_INVOICE')} : </label> سرویس  {location.state?.package?.packageTitleFa}  {handleDisplayDuration()}</div>
                }

                {location?.state?.upgradePackageResult && location.state.reducedPrice > 0 &&
                    <div className="upgrade-package-message mt-3" >
                        در  محاسبه‌ مبلغ باقیمانده‌ی بسته‌ی فعلی لحاظ شده و از هزینه‌ی بسته جدید کسر می‌گردد.
                    </div>}


                {/* {location?.state?.upgradePackageResult ?
                 <div className="detail-container" >
               
                    <div>
                        <label>{t("TITLE.INVOICE.AMOUNT")}</label>
                        <label>{enToPersianChar(new Intl.NumberFormat().format(location.state.originPackagePrice / 10))}{returnCurrency()}</label>
                    </div>
                  
                    <div>
                        <label>{t("TITLE.TAX")}</label>
                        <label>{enToPersianChar(0)}</label>
                    </div>
                    <div className="discount">
                        <label>{t("TITLE.DISCOUNTS")}</label>
                        <label>{enToPersianChar(0)}</label>
                    </div>
                    {location?.state?.upgradePackageResult && location?.state?.reducedPrice > 0 && <div>
                        <label>{t("TITLE.INVOICE.CURRENT_PACKAGE_AMOUNT_REDUCED")}</label>
                        <label >{enToPersianChar(new Intl.NumberFormat().format(location?.state?.reducedPrice / 10)) + "-" + returnCurrency()}</label>

                    </div>}
                    <hr />
                    <div className="payable-price">
                        <label>مبلغ قابل پرداخت</label>
                        <label>{enToPersianChar(new Intl.NumberFormat().format(price / 10)) + returnCurrency()}</label>
                    </div>


                </div> : */}

                <div className="detail-container" >

                    <div>
                        <label>{t("TITLE.INVOICE.AMOUNT")}</label>
                        <label>{enToPersianChar(new Intl.NumberFormat().format(invoiceDetail.extraInfo.subtotal / 10)) + returnCurrency()}</label>
                    </div>
                    <div>
                        <label>{t("TITLE.TAX")}</label>
                        <label>{enToPersianChar(new Intl.NumberFormat().format(invoiceDetail.extraInfo.tax / 10)) + returnCurrency()}</label>
                    </div>
                    <div className="discount">
                        <label>{t("TITLE.DISCOUNTS")}</label>
                        <label>{enToPersianChar(0)}</label>
                    </div>
                    <hr />
                    <div className="payable-price">
                        <label>مبلغ قابل پرداخت</label>
                        <label>{enToPersianChar(new Intl.NumberFormat().format(invoiceDetail.extraInfo.total / 10)) + returnCurrency()}</label>
                    </div>


                </div>
                {/* } */}
                <div className="gateway-container" >
                    <div className="selected">
                        <figure>
                            <img src={bpLogo} />

                        </figure>
                    </div>
                </div>
            </div>
            <div className="d-flex flex-row justify-content-end m-3">

                {status === "Unpaid" && selected === "mellat" && <div>
                    <form className="btn-custom" method="post" ref={formRef} action={process.env.REACT_APP_BANK_GATEWAY}>
                        <input type="hidden" name="invoiceid" value={invoiceId} />
                        <input type="hidden" name="amount" value={invoiceDetail.extraInfo.total} />
                        <input type="hidden" name="email" value={user?.email} />
                        <input type="hidden" name="currencies" value="rial" />
                        <input type="button" name="pay"
                            onClick={triggerSubmit}
                            className="btn btn-primary btn-custom-height" value=" پرداخت آنلاین" />
                    </form>
                </div>}

                {status === "Unpaid" && selected === "nowpayments" &&
                    <input
                        type="button"
                        className='btn btn-primary btn-custom '
                        onClick={nowPaymentsAction}
                        value={t('ONLINE_PAYMENT')} />
                }
                {status === "Unpaid" && selected === "mailin" &&
                    <span>Reference Number:{invoiceId}</span>
                }
            </div>
        </>


    )
}
export default PayPageContent